import { render, staticRenderFns } from "./NoticeShow.vue?vue&type=template&id=dbe99cd6&scoped=true&"
import script from "./NoticeShow.vue?vue&type=script&lang=js&"
export * from "./NoticeShow.vue?vue&type=script&lang=js&"
import style0 from "./NoticeShow.vue?vue&type=style&index=0&id=dbe99cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe99cd6",
  null
  
)

export default component.exports